function login({
  commit
}, user) {
  commit('LOGIN', user)
}

function logout({
  commit
}) {
  commit('LOGOUT')
}

export default {
  LOGIN: login,
  LOGOUT: logout
}